import { computed, observable } from "mobx";
import type Month from "../entities/month";
import type EdazLivingMonthsRepository from "../repositories/edazLivingMonthsRepository";
import MonthOption from "../utils/monthOption";

export default class MonthOptionsService {
  @observable private sourceMonths: Month[];
  @observable private _startOfMonthOptions: MonthOption[];
  @observable private _endOfMonthOptions: MonthOption[];

  @computed
  get startOfMonthOptions() {
    return this._startOfMonthOptions;
  }

  @computed
  get endOfMonthOptions() {
    return this._endOfMonthOptions;
  }

  @computed
  get monthOptions() {
    return this.sourceMonths.map(month => ({ id: month.name, label: month.name }));
  }

  constructor(private repository: EdazLivingMonthsRepository) {
    this.initialize();
  }

  private initialize() {
    this.sourceMonths = this.repository.createMonths(true);
    const sourceMonths = this.repository.createMonths(false);
    this._startOfMonthOptions = MonthOption.makeStartOptions(sourceMonths);
    this._endOfMonthOptions = MonthOption.makeEndOptions(sourceMonths);
  }
}
